import * as types from '../actions/actionTypes';
import initialState from "./initialState";


export function mealReducer(
    state = initialState.meal, action
) {
    switch(action.type) {
        case types.ADD_MEAL_SUCCESS:
            return action.meal;
        case types.EDIT_MEAL_SUCCESS:
            return action.meal;
        case types.FETCH_MEAL_SUCCESS:
            return action.meal;
        case types.REMOVE_MEAL_SUCCESS:
            return action.response;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/mealReducer.js